import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CheckoutPaymentChequePage } from 'src/app/modals/checkout-payment-cheque/checkout-payment-cheque.page';

const routes: Routes = [
  {
    path: '',
    component: CheckoutPaymentChequePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CheckoutPaymentChequePage]
})
export class CheckoutPaymentChequePageModule {}
